const index = {
  name: 'trainingCertQueryResult',
  path: 'result',
  props: true,
  component: resolve => require(['../../../../../../pages/portal/sbs/training/cert-query/result'], resolve)
}

export default index
